import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useDataGridFetcher } from '../useDataGridFetcher';

export const LIST_TENANT_USERS_QUERY_KEY = 'users.listTenantUsers';

export const getTenantUsersQueryKey = ({
  page,
  perPage,
  tenantId,
}: {
  page?: string | number;
  perPage?: string | number;
  tenantId?: string;
}) => [
  LIST_TENANT_USERS_QUERY_KEY,
  {
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    tenantId,
  },
];

const queryFunction =
  ({ page, perPage, tenantId }: { page?: string | number; perPage?: string | number; tenantId?: string }) =>
  () =>
    api.users.listTenantUsers({
      tenantId: tenantId ?? '',
      page: +(page ?? 1),
      perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    });

export const useFetchTenantUsers = () => {
  const { getTenantId } = useTenants();
  return useDataGridFetcher({
    queryKey: parameters => getTenantUsersQueryKey({ tenantId: getTenantId(), ...parameters }),
    queryFn: parameters => queryFunction({ tenantId: getTenantId(), ...parameters }),
  });
};
